import styled, { css } from "styled-components";

const getColor = (color) => {
    switch (color) {
        case 'success':
            return 'var(--color-success)';
        case 'error':
            return 'var(--color-error)';
        case 'warning':
            return 'var(--color-warning)';
        default:
            return 'var(--theme-color-primary)';
    }
};

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--theme-color-primary);
  border-radius: 3em;
  font-weight: 600;

  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
  transition: all ease-in-out 0.3s;

  ${(props) => props.size === 'small' && css`
    width: 30px;
    aspect-ratio: 1;
  `}

  ${(props) => props.size === 'medium' && css`
    width: 35px;
    aspect-ratio: 1;
  `}

  ${(props) => props.size === 'large' && css`
    width: 40px;
    aspect-ratio: 1;
  `}

  ${(props) =>
        props.$outline
            ? css`
          background-color: transparent;
          color: ${getColor(props.color)};
        `
            : css`
          background-color: ${getColor(props.color)};
          color: var(--theme-color-white);
          opacity: 0.9;

          &:hover:not(:disabled) {
            opacity: 1;
          }
        `}

  ${(props) => props.color && css`
    border-color: ${getColor(props.color)};
  `}

  &:disabled {
    filter: grayscale(1);
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    width: 50%;
    height: auto;
  }

  ${(props) =>
        props.$outline &&
        css`
          &:hover:not(:disabled) {
          background-color: ${getColor(props.color)};
          color: var(--theme-color-white);
        }`
      }
`;